import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as AppCreationStatusShopAPI from "@/api/app-creation-status-shop";
import { CommonResponse, isSuccess } from "@/api/response";
import { RegisterRequest } from "@/api/app-creation-status-shop/request";

const MODULE_NAME = "app-creation-status-shop/modify";

/**
 * アプリ作成状況登録更新APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Modify extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  @MutationAction
  async register(registerRequest: RegisterRequest) {
    const commonResponse = await AppCreationStatusShopAPI.register(
      registerRequest
    );
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Modify);
